import { Double, Identifiers, Long, Properties } from "../model/model"
import Event from "./Event"

export interface EventPayloadDto {
  exposureEvents: ExposureEventDto[]
  trackEvents: TrackEventDto[]
}

export interface ExposureEventDto {
  timestamp: Long

  userId?: string
  identifiers: Identifiers
  userProperties: Properties
  hackleProperties: Properties

  experimentId: Long
  experimentKey: Long
  experimentType: string
  experimentVersion: Long
  variationId?: Long
  variationKey: string
  decisionReason: string
}

export interface TrackEventDto {
  timestamp: Long

  userId?: string
  identifiers: Identifiers
  userProperties: Properties
  hackleProperties: Properties

  eventTypeId: Long
  eventTypeKey: string
  value: Double
  properties: Properties
}

export function toPayload(events: Event[]): EventPayloadDto {
  const exposures = new Array<ExposureEventDto>()
  const tracks = new Array<TrackEventDto>()

  events.forEach((event) => {
    if (Event.isExposure(event)) {
      exposures.push(event.toDto())
    } else if (Event.isTrack(event)) {
      tracks.push(event.toDto())
    }
  })

  return {
    exposureEvents: exposures,
    trackEvents: tracks
  }
}
